// filepath: apps/web/src/main.tsx
//
// Application entry point. Mounts <App /> into #root.
//
// FR-UI-CORE-8: the side-effect import of `@/i18n` (the i18n module's
// barrel re-export) initializes the i18next singleton at boot. Must
// come BEFORE the React tree is rendered so `useTranslation()` works
// inside any descendant component on first render.
//
// In production, a follow-up workflow (FR-UI-CORE-2) wires OIDC bootstrap
// and resolves tenantSlug from the subdomain. In this scaffold, the
// tenantSlug is supplied as a runtime prop on <App /> (see App.tsx) or
// defaulted to "local" when absent (test-mode).

import "@/i18n";
import "@/styles/design-system/styles.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import i18n from "@/i18n/i18n";
import { setDocumentLocale } from "@/runtime/setDocumentLocale";

const container = document.getElementById("root");
if (!container) {
  throw new Error("main.tsx: #root element not found in index.html");
}

// FR-UI-CORE-9: set <html lang> and <title> from the active
// i18next locale on boot, and re-run on every languageChanged
// event. The static <html lang="ru"> default in index.html matches
// the i18next boot locale (ru) so the initial paint is correct
// before this effect runs.
setDocumentLocale((i18n.language as "ru" | "kk" | "en") || "ru");
i18n.on("languageChanged", (lang) => {
  setDocumentLocale(lang as "ru" | "kk" | "en");
});

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
